// use-docs-list.hook.ts
import { useEffect, useState } from 'react'

import { searchDocsService } from '../services/search-docs.service'
import type { Manual } from '../types/release.type'

export function useDocsList() {
  const [docs, setDocs] = useState<Manual[]>([])
  const [initialDocs, setInitialDocs] = useState<Manual[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [isInitialLoading, setIsInitialLoading] = useState(true)
  const [query, setQuery] = useState('')

  useEffect(() => {
    const loadInitialDocs = async () => {
      setIsInitialLoading(true)
      try {
        const response = await searchDocsService({ query: 'a' })
        setInitialDocs(response.docs)
      } catch (error) {
        console.error('Erro ao carregar documentos iniciais', error)
      } finally {
        setIsInitialLoading(false)
      }
    }

    loadInitialDocs()
  }, [])

  const handleFetchDocs = async () => {
    if (!query.trim()) {
      setDocs([])
      return
    }

    setIsLoading(true)
    try {
      const response = await searchDocsService({ query })
      setDocs(response.docs)
    } catch (error) {
      console.error('Erro ao buscar documentos', error)
      setDocs([])
    } finally {
      setIsLoading(false)
    }
  }
  return {
    docs,
    initialDocs,
    isLoading,
    isInitialLoading,
    query,
    setQuery,
    handleFetchDocs,
  }
}